import React, { useState, useEffect } from "react";

const InputPassport = ({
  name,
  value = "",
  onChange,
  placeholder,
  label,
  required = false,
  readOnly = false,
  setInputPassportError
}) => {
  const [errMsg, setErrMsg] = useState("");

  const handleBlur = () => {
    const passportRegex = /^[A-Z][0-9]{7}$/;
    if (required && value?.length === 0) {
      setErrMsg("Please enter a valid passport number.");
      setInputPassportError((prevState) => ({
        ...prevState,
        passport: true,
      }));
    } else if (value?.length > 0 && !passportRegex.test(value)) {
      setErrMsg("Passport number must start with an uppercase letter followed by 7 digits.");
      setInputPassportError((prevState) => ({
        ...prevState,
        passport: true,
      }));
    } else {
      setErrMsg("");
      setInputPassportError((prevState) => ({
        ...prevState,
        passport: false,
      }));
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value.toUpperCase();
    onChange({ target: { name, value: inputValue } });

    if (errMsg) {
      setErrMsg("");
      setInputPassportError((prevState) => ({
        ...prevState,
        passport: false,
      }));
    }
  };

  useEffect(() => {
    if (!errMsg) {
      setInputPassportError((prevState) => ({
        ...prevState,
        passport: false,
      }));
    }
  }, [errMsg, setInputPassportError]);

  return (
    <div className="form-group">
      <label htmlFor={name} className="col-form-label">
        {label}
      </label>
      <input
        type="text"
        className="form-control"
        name={name}
        value={value}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={placeholder}
        required={required}
        readOnly={readOnly}
      />
      <small className="text-danger">{errMsg}</small>
    </div>
  );
};

export default InputPassport;
